import {ReactComponent as HinduSymbol} from '../assets/hindu-religion.svg';
import {ReactComponent as SikhSymbol} from '../assets/sikh-religion.svg';
import {ReactComponent as IslamSymbol} from '../assets/islam-religion.svg';
import {ReactComponent as ChristianSymbol} from '../assets/christian-religion.svg';
import {ReactComponent as HinduSmallSymbol} from '../assets/hindu-faith.svg';
import {ReactComponent as SikhSmallSymbol} from '../assets/sikh-faith.svg';
import {ReactComponent as IslamSmallSymbol} from '../assets/islam-faith.svg';
import {ReactComponent as ChristianSmallSymbol} from '../assets/christian-faith.svg';
import {ReactComponent as HinduSmallSelectedSymbol} from '../assets/selected-hindu-symbol.svg';
import {ReactComponent as SikhSmallSelectedSymbol} from '../assets/selected-sikh-symbol.svg';
import {ReactComponent as IslamSmallSelectedSymbol} from '../assets/selected-islam-symbol.svg';
import {ReactComponent as ChristianSmallSelectedSymbol} from '../assets/selected-christian-symbol.svg';

import HinduPrayer from '../assets/hindu-prayer.mp3';
import SikhPrayer from '../assets/sikh-prayer.mp3';
import IslamPrayer from '../assets/islam-prayer.mp3';
import ChristianPrayer from '../assets/christian-prayer.mp3';

import GaneshaJiImage from '../assets/ganesha-ji.png';
// import DurgaJiImage from '../assets/durga-ji.png';
// import RamaJiImage from '../assets/rama-ji.png';
// import KrishnaJiImage from '../assets/krishna-ji.png';
// import SaiJiImage from '../assets/sai-ji.png';
// import ShivaJiImage from '../assets/shiva-ji.png';
import GuruNanakDevJiImage from '../assets/guru-nanak-dev-ji.png';
// import GuruGranthSahibJiImage from '../assets/guru-granth-sahib-ji.png';
import MeccaImage from '../assets/mecca.png';
// import QuranImage from '../assets/quran.png';
// import MotherMarryImage from '../assets/mother-marry.png';
import LordJesusChristImage from '../assets/lord-jesus-christ.png';

import {ReactComponent as Flower1} from '../assets/flower-1.svg';
import {ReactComponent as Flower1Disabled} from '../assets/flower-1-disabled.svg';
import {ReactComponent as Diya1} from '../assets/diya-1.svg';
import {ReactComponent as Diya1Disabled} from '../assets/diya-1-disabled.svg';
import {ReactComponent as Candle1} from '../assets/candle-1.svg';
import {ReactComponent as Candle1Disabled} from '../assets/candle-1-disabled.svg';
import {ReactComponent as Diya2} from '../assets/diya-2.svg';
import {ReactComponent as Diya2Disabled} from '../assets/diya-2-disabled.svg';
import {ReactComponent as OfferNamaz} from '../assets/offer-namaz.svg';
import {ReactComponent as OfferNamazDisabled} from '../assets/offer-namaz-disabled.svg';


import GaneshaJiFlower1 from '../assets/ganesha-ji-flower-1.gif';
import GaneshaJi from '../assets/ganesha-ji.gif';
import GaneshaJiDiya1 from '../assets/ganesha-ji-diya-1.gif';

import GuruNanakDevJiFlower1 from '../assets/guru-nanak-dev-ji-flower-1.gif';
import GuruNanakDevJi from '../assets/guru-nanak-dev-ji.gif';
import GuruNanakDevJiDiya2 from '../assets/guru-nanak-dev-ji-diya-2.gif';

import LordJesusChrist from '../assets/lord-jesus-christ.gif';
import LordJesusChristCandle1 from '../assets/lord-jesus-christ-candle-1.gif';

import Mecca from '../assets/mecca.gif';
import MeccaNamaz from '../assets/mecca-namaz.gif';

const faiths = [
    {
        key: 'hindu',
        name: 'Hindu',
        symbol: (HinduSymbol),
        smallSymbol: (HinduSmallSymbol),
        smallSelectedSymbol: (HinduSmallSelectedSymbol),
        gods: [
            {
                "key": "ganesh_ji",
                "image": GaneshaJiImage,
                "defaultWorshipGif": GaneshaJi,
                "prayerMusic": HinduPrayer,
                "worshipOptions": [
                    {
                        key: "flower-1",
                        enabledOptionImage: Flower1,
                        disabledOptionImage: Flower1Disabled,
                        gif: GaneshaJiFlower1 
                    },
                    {
                        key: "diya-1",
                        enabledOptionImage: Diya1,
                        disabledOptionImage: Diya1Disabled,
                        gif: GaneshaJiDiya1
                    }
                ],
            },
            // {
            //     "key": "durga_ji",
            //     "image": DurgaJiImage
            // },
            // {
            //     "key": "rama_ji",
            //     "image": RamaJiImage
            // },
            // {
            //     "key": "krishna_ji",
            //     "image": KrishnaJiImage
            // },
            // {
            //     "key": "sai_ji",
            //     "image": SaiJiImage
            // },
            // {
            //     "key": "shiva_ji",
            //     "image": ShivaJiImage
            // },
            
        ]
    },
    {
        key: 'sikh',
        name: 'Sikh',
        symbol: (SikhSymbol),
        smallSymbol: (SikhSmallSymbol),
        smallSelectedSymbol: (SikhSmallSelectedSymbol),
        gods: [
            {
                key: "guru_nanak_ji",
                image: GuruNanakDevJiImage,
                "defaultWorshipGif": GuruNanakDevJi,
                "prayerMusic": SikhPrayer,
                "worshipOptions": [
                    {
                        key: "flower-1",
                        enabledOptionImage: Flower1,
                        disabledOptionImage: Flower1Disabled,
                        gif: GuruNanakDevJiFlower1 
                    },
                    {
                        key: "diya-2",
                        enabledOptionImage: Diya2,
                        disabledOptionImage: Diya2Disabled,
                        gif: GuruNanakDevJiDiya2
                    }
                ],
            },
            // {
            //     key: "guru_granth_sahib_ji",
            //     image: GuruGranthSahibJiImage
            // }
        ]
    },
    {
        key: 'islam',
        name: 'Islam',
        symbol: (IslamSymbol),
        smallSymbol: (IslamSmallSymbol),
        smallSelectedSymbol: (IslamSmallSelectedSymbol),
        gods: [
            {
                key: "mecca",
                image: MeccaImage,
                "defaultWorshipGif": Mecca,
                "prayerMusic": IslamPrayer,
                "worshipOptions": [
                    {
                        key: "flower-1",
                        enabledOptionImage: OfferNamaz,
                        disabledOptionImage: OfferNamazDisabled,
                        gif: MeccaNamaz 
                    }
                ],
            },
            // {
            //     key: "quran",
            //     image: QuranImage
            // }
        ]
    },
    {
        key: 'christian',
        name: 'Christian',
        symbol: (ChristianSymbol),
        smallSymbol: (ChristianSmallSymbol),
        smallSelectedSymbol: (ChristianSmallSelectedSymbol),
        gods: [
            // {
            //     key: "mother_marry",
            //     image: MotherMarryImage
            // },
            {
                key: "lord_jesus_christ",
                image: LordJesusChristImage,
                "defaultWorshipGif": LordJesusChrist,
                "prayerMusic": ChristianPrayer,
                "worshipOptions": [
                    {
                        key: "candle-1",
                        enabledOptionImage: Candle1,
                        disabledOptionImage: Candle1Disabled,
                        gif: LordJesusChristCandle1 
                    }
                ],
            }
        ]
    }
]


export default faiths;